import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, Users, Package, User } from "lucide-react";

const menuItems = [
  { name: "Dashboard", icon: Home, path: "/dashboard" },
  { name: "Customers", icon: Users, path: "/customer" },
  { name: "Orders", icon: Package, path: "/order" },
  { name: "Profile", icon: User, path: "/profile" },
];

const Sidebar = () => {
  return (
    <>
      {/* ================= DESKTOP TOP NAV ================= */}
      <header
        className="
  hidden lg:flex
  fixed top-4 left-1/2 -translate-x-1/2
  z-40
  w-[calc(100%-6rem)]
  max-w-7xl
  rounded-3xl
  bg-gradient-to-br from-orange-50/80 to-white/80
  backdrop-blur-md
  border border-orange-100
"
      >
        <nav className="flex items-center justify-center gap-1 px-4 h-[72px] w-full">
          {menuItems.map((item) => {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `
            group relative
            flex items-center gap-2
            px-4 py-2
            rounded-2xl
            text-sm font-medium
            transition-all duration-300
            ${
              isActive
                ? "text-orange-600 bg-orange-100/60"
                : "text-gray-600 hover:text-gray-900 hover:bg-orange-50/60"
            }
            `
                }
              >
                <Icon
                  size={18}
                  className="opacity-90 group-hover:opacity-100"
                />
                <span className="text-black font-bold opacity-90">
                  {item.name}
                </span>

                {/* Active indicator */}
                <span
                  className={`
              absolute left-4 right-4 -bottom-[6px]
              h-[2px] rounded-full
              transition-all duration-300
              ${
                window.location.pathname === item.path
                  ? "bg-orange-500"
                  : "bg-transparent"
              }
            `}
                />
              </NavLink>
            );
          })}
        </nav>
      </header>

      {/* ================= MOBILE BOTTOM NAV ================= */}
      <nav
        className="
    lg:hidden
    fixed bottom-1 left-1/2 -translate-x-1/2
    z-40
    w-[calc(105%-2rem)]
    max-w-md
    px-4 py-3
    rounded-3xl
    bg-gradient-to-br from-orange-50 to-white
    shadow-xl
    border
    flex items-center justify-center gap-6
  "
      >
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = window.location.pathname === item.path;

          return (
            <NavLink
              key={item.name}
              to={item.path}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center w-16 h-16 rounded-2xl
     transition-all duration-300 ease-out
     ${
       isActive
         ? "bg-orange-500 text-white -translate-y-5 shadow-lg p-2"
         : "text-gray-500 hover:bg-gray-100"
     }`
              }
            >
              <Icon size={22} />

              <span
                className={`text-[11px] mt-1 font-medium transition-opacity
      ${active ? "opacity-100" : "opacity-80"}`}
              >
                {item.name}
              </span>
            </NavLink>
          );
        })}
      </nav>
    </>
  );
};

export default Sidebar;
